import { Component, OnInit, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../auth/auth.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-logedin',
  templateUrl: './logedin.component.html',
  styleUrls: ['./logedin.component.css'],
})
export class LogedinComponent implements OnInit {
  importxls: FormGroup;
  importxlsNew: FormGroup;
  newUserId: number;
  newEventId: number;
  selectedIndexo: number = 0;
  contentHide: boolean = true;
  selectedFile: File = null;
  chartd: any;
  chrtdat: boolean;
  projectName: string | number | boolean;
  embCode: string | number | boolean;
  btnStatus$: Observable<boolean>;
  newprojUserId: string;
  newprojProjId: string;
  testusid: string;
  prid: string | number | boolean;
  chartdnew: any;
  num_rec: Object;
  newProjId: number;
  chk_stat: boolean;
  rootDomainUrl: string;

  constructor(
    private authService: AuthService,
    private elem: ElementRef,
    public snackBar: MatSnackBar,
    private http: HttpClient,
    private router: Router
  ) {}
  clickMeForward() {
    this.selectedIndexo++;
  }

  clickMeBack() {
    this.selectedIndexo--;
    this.router.navigate(['/mrfd']);
  }
  selectedIndexChangeNew(val: number) {
    this.selectedIndexo = val;
  }

  saveEmbCode() {
    const bodyparm = new HttpParams()
      .set('user_id', this.newEventId.toString())
      .set('proj_name', this.projectName)
      .set('emb_code', this.embCode);
    this.http
      .post(this.rootDomainUrl + 'adeos/api/proj_code.php', bodyparm)
      .subscribe((data) => {});
  }

  ngOnInit() {
    this.rootDomainUrl = this.authService.rootDomainUrl;
    this.chk_stat = true;
    this.authService.currentprojId.subscribe(
      (newProjId) => (this.newProjId = newProjId)
    );
    this.testusid = localStorage.getItem('usid');
    this.prid = localStorage.getItem('prid');

    if (this.testusid !== null) {
      this.selectedIndexo++;
    }
    this.btnStatus$ = this.authService.btnStatus;
    this.authService.currenteventId.subscribe(
      (newEventId) => (this.newEventId = newEventId)
    );

    this.authService.currentUserId.subscribe(
      (newUserId) => (this.newUserId = newUserId)
    );
    this.importxls = new FormGroup({
      xlspath: new FormControl('', Validators.required),
    });

    this.importxlsNew = new FormGroup({
      xlspathNew: new FormControl('', Validators.required),
    });
  }

  Upload_data() {
    this.chk_stat = false;

    const bodyparm = new HttpParams()
      .set('user_id', this.newEventId.toString())
      .set('proj_id', this.prid);
    this.http
      .post(this.rootDomainUrl + 'adeos/api/insert_all_data.php', bodyparm)
      .subscribe((data) => {});
  }
  removeStorage() {
    localStorage.removeItem('usid');
    localStorage.removeItem('prid');
  }

  uploadImage() {
    this.chrtdat = true;
    this.selectedIndexo++;
    const bodyparm = new HttpParams()
      .set('user_id', this.newEventId.toString())
      .set('proj_name', this.projectName);

    this.http
      .post(this.rootDomainUrl + 'adeos/api/add_new_project.php', bodyparm)
      .subscribe((data) => {
        this.snackBar.open('Project added successfully ', 'clear', {
          duration: 5000,
        });
        this.chartd = data;
        this.newprojUserId = this.chartd.userid;
        this.newprojProjId = this.chartd.projid;
        localStorage.setItem('usid', this.newprojUserId);
        localStorage.setItem('prid', this.newprojProjId);
        this.testusid = localStorage.getItem('usid');
        this.prid = localStorage.getItem('prid');

        
      });
  }

  get_exp_rec() {
    const bodyparm = new HttpParams()
      .set('user_id', this.newEventId.toString())
      .set('proj_id', this.prid);
    this.http
      .post(
        this.rootDomainUrl + 'adeos/api/check_extrapolation_status.php',
        bodyparm
      )
      .subscribe((data) => {
        this.num_rec = data;
      });
  }

  refreshmrfd() {
    this.router
      .navigateByUrl('/register', { skipLocationChange: true })
      .then(() => this.router.navigate(['logedin']));
  }

  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
  }
}
